import { render, staticRenderFns } from "./CollectionsTab.vue?vue&type=template&id=7e75301c&scoped=true"
import script from "./CollectionsTab.vue?vue&type=script&lang=js"
export * from "./CollectionsTab.vue?vue&type=script&lang=js"
import style0 from "./CollectionsTab.vue?vue&type=style&index=0&id=7e75301c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e75301c",
  null
  
)

export default component.exports